// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"96f100cb","453":"0eb3d5ee","553":"eaf87a4e","977":"7843e45a"}[chunkId] + ".chunk.js";
};